import type { Locale } from './index'
import type { WeekStartDay, TimeFormat } from '@/services/locale.service'

export const LOCALE_DEFAULTS: Record<Locale, {
  weekStartDay: WeekStartDay
  timeFormat: TimeFormat
}> = {
  'en':    { weekStartDay: 'sunday', timeFormat: '12h' },
  'fr':    { weekStartDay: 'monday', timeFormat: '24h' },
  'es':    { weekStartDay: 'monday', timeFormat: '24h' },
  'pt-BR': { weekStartDay: 'sunday', timeFormat: '24h' },
  'de':    { weekStartDay: 'monday', timeFormat: '24h' },
  'it':    { weekStartDay: 'monday', timeFormat: '24h' },
  'nl':    { weekStartDay: 'monday', timeFormat: '24h' },
  'pl':    { weekStartDay: 'monday', timeFormat: '24h' },
  'uk':    { weekStartDay: 'monday', timeFormat: '24h' },
}
